import React from 'react';
import styled from 'styled-components';
import Button from '../Button/Button';
export default function CircleButton(_ref) {
  let { ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledButton, props);
}
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "CircleButton__StyledButton",
  componentId: "sc-112wgqg-0"
})(["&.small{border-radius:50%;padding:0px;height:30px;width:30px;font-size:14px;}&.medium{border-radius:50%;padding:0px;height:40px;width:40px;font-size:20px;}&.large{border-radius:50%;padding:0px;height:120px;width:120px;font-size:60px;}svg{margin-right:0;}"]);